import { addEnumStmtInstruction } from './CreateEnumStmt';
import { addEnumValueStmtInstruction } from './AddEnumValueStmt';
import { removeEnumStmtInstruction } from './RemoveEnumStmt';
import { removeEnumValueStmtInstruction } from './RemoveEnumValueStmt';
export const enumInstruction = `
### Enums

${addEnumStmtInstruction}
${addEnumValueStmtInstruction}
${removeEnumStmtInstruction}
${removeEnumValueStmtInstruction}

#### Connect enum to entity
Enum can be connected to an entity by adding a column with the enum name as type.

- Syntax: \`add column <entity_name>.<enum_name> <enum_nane>;\`
- Example: \`add column Inquiry.status inquiryStatus;\`
`;
//# sourceMappingURL=enumInstruction.js.map